import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function scrollToId(id) {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70, duration: 1.4 });
    else el.scrollIntoView({ behavior: "smooth" });
}

export function Reveal({ children, className = "", delay = 0, y = 36, testid }) {
    return (
        <motion.div
            data-testid={testid}
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function Eyebrow({ index, children, light = false }) {
    return (
        <Reveal>
            <div className="flex items-center gap-4">
                <span className={`font-mono text-[11px] tracking-[0.3em] ${light ? "text-sand" : "text-clay"}`}>{index}</span>
                <span className={`h-px w-10 ${light ? "bg-cream/30" : "bg-earth/40"}`} />
                <span className={`font-mono text-[11px] uppercase tracking-[0.3em] ${light ? "text-cream/70" : "text-earth"}`}>{children}</span>
            </div>
        </Reveal>
    );
}
